export default __webpack_public_path__ + "static/media/pencil-one.3c40ca57.svg";